module.exports = (__parcel__import__("964dy")).then(() => parcelRequire('fyWP3'));